import React from 'react';
import { Roles } from '../../commonType';
import { getLoggedinUserGroups } from '../../util';

const withRoles = (Component: any) => {
  // eslint-disable-next-line react/display-name
  return (props: any) => {
    const groups = getLoggedinUserGroups() ?? [];
    const ccPaymentGroup = process.env.REACT_APP_ALLOWED_CC_PAYMENT_GROUP ?? '';
    let currentRole =
      groups.filter((x) => x != null && x.toLocaleLowerCase() === ccPaymentGroup.toLocaleLowerCase()).length > 0
        ? Roles.Field_Associate
        : Roles.Call_Center_Associate;
    const requestedRole = sessionStorage.getItem('REQUESTED_ROLE') ?? '';
    currentRole =
      currentRole === Roles.Field_Associate
        ? requestedRole === 'ca'
          ? Roles.Call_Center_Associate
          : currentRole
        : currentRole;
    return (
      <>
        <Component userRole={currentRole} {...props}></Component>
      </>
    );
  };
};
export default withRoles;
